export default __webpack_public_path__ + "static/angular12-boilerplate-template-2d27d03b9b9719df109642eb182a536a.png";